<template>

    <div  class="classPageDiv">
  
      <div class=" mt-4 rounded">
  
          <div v-if="classImages.length > 0" class="">
  
              <card-images-component :images="classImages" :isTransparent="false"/>
          </div>
  
              
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.className')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myMembership.class.name}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.membershipName')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myMembership.name}}</label>
          </div>
          
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.instructorName')}} </strong></label>
              
              <label
              class="classPageDetailsLabel">
              {{myMembership.class.instructor_name}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('memberships.noOfClasses')}}</strong></label>
  
              <label
              class="classPageDetailsLabel">
                  {{myMembership.classes_number}}
              </label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('memberships.period')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
                  {{membershipPeriod()}}
              </label>
          </div>
  
          <div v-if="myMembership.pay_cash" class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.cash')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
                  {{myMembership.cash_price}}
              </label>
          </div>
  
          <div v-if="myMembership.pay_points" class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.points')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
                  {{myMembership.price}}
              </label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.level')}} </strong></label>
              
              <label
              class="classPageDetailsLabel">
              {{myMembership.class.level}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.type')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{type}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.description')}} </strong></label>
  
              <p
              class="classPageDetailsLabel">
              {{myMembership.class.description}}</p>
          </div>
  
  
          <div class="w-full">
  
              <div v-for="(item, i) in myMembership.three_class_membership_to_schedules" :key="i" 
              class="h-full overflow-y-scroll">
  
                  <div class="mt-2">
  
                      <label class="classPageDetailsLabel"><strong>{{$t('memberships.schedule#')}} {{i+1}} </strong></label>
                  </div>
  
                  <div class="mt-4 mb-10">
                      <membership-schedule :schedule="item.three_class_schedule"/>
                  </div>
              </div>
  
          </div>
  
          <!-- <div class="mb-40" v-if="stopLoader && (classInfo != null ||  typeof stopLoader == 'undefined')"> -->
          <div class="mb-40">
  
              <div>
  
                  <div>
  
                      <div class="text-xs lg:text-lg font-bold mb-1">
  
                      <label>{{$t('memberships.paymentBy')  }}</label>
  
                      </div>
                      <div class="classPageDetailsSwitchParent">
  
                          <div v-if="myMembership.pay_cash" :class="{'bg-green-500': !paymentByPoints}"
                          @click="paymentByPoints = false"  class="classPageDetailsSwitch">
                              
                              <div>
  
                                  <label class=""><strong>{{$t('classes.cash')}} </strong></label>
                              </div>
  
                              <div 
                          class="w-24">
  
  
                                  <label :class="{'bg-green-500': !paymentByPoints}"
                                  class="">
                                      {{myMembership.cash_price}}
                                  </label>
                              </div>
                          </div>
  
                          <div v-if="enablePaymentSwitch" class="w-12 bg-pink-800">
  
  
                          </div>
                          
                          <div v-if="myMembership.pay_points" :class="{'bg-green-500': paymentByPoints}"
                          @click="paymentByPoints = true"  class="classPageDetailsSwitch">
  
                              
                              <div>
  
                                  <label class=""><strong>{{$t('classes.points')}} </strong></label>
                              </div>
  
                              <div 
                          class="w-24">
  
                                  <label
                                  class="">
                                      {{myMembership.price}}
                                  </label>
                              </div>
                          </div>
                      </div>
                  </div>  
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  
  
  // import sessionsPanel from '../panels/SessionsPanel';
  
  import componentsHelpers from '../../classes/componentHelpers';
  
  import cardImagesComponent from '../../components-v2/cards-components/CardImages';
  
  import myQueries from '../../hasura/myQueries';
  
  import myInserts from '../../hasura/myInserts';
  
  import moment from 'moment'
  
  
  import componentsMethods from '../../classes/componentsMethods';
  
  import myDateBar from '../../components-v2/Bars/MyDatesBar'
  
  import membershipSchedule from '../../components-v2/cards-components/MembershipScheduleDetails'
  
  // import axios from '@/classes/myAxios'
  import axios from '@/classes/myAxios'
  
  // import MyTabs from '../components-v2/controls/MyTabs';
  
  export default {
  
      created()
      {
          // console.log(`myMembership: ${JSON.stringify(this.myMembership)}`);
    
          if(this.myMembership.class.instructor_name != ''){
  
                  this.instructorName = this.myMembership.class.instructor_name;
          }
  
         else if(this.myMembership.class.instructor.name != ''){
  
              this.instructorName = this.myMembership.class.instructor.name;
          }
          this.setType();
          this.setFacility();
      },
  
      mounted(){
  
          this.setPaymentSwitch();
  
              // console.log(`in class page`);
              // console.log(`myMembership: ${JSON.stringify(this.myMembership.id)}`);
          try{
  
              if(this.myMembership.class.image_1 != null && this.myMembership.class.image_1 != ''){
  
                  this.classImages.push(this.myMembership.class.image_1);
  
                  if(this.myMembership.class.image_2 != null && this.myMembership.class.image_2 != ''){
  
                      this.classImages.push(this.myMembership.class.image_2);
                      
                      if(this.myMembership.class.image_3 != null && this.myMembership.class.image_3 != ''){
  
                          this.classImages.push(this.myMembership.class.image_3);
  
                          if(this.myMembership.class.image_4 != null && this.myMembership.class.image_4 != ''){
  
                              this.classImages.push(this.myMembership.class.image_4);
  
                              if(this.myMembership.class.image_5 != null && this.myMembership.class.image_5 != ''){
  
                                  this.classImages.push(this.myMembership.class.image_5);
  
                                  if(this.myMembership.class.image_6 != null && this.myMembership.class.image_6 != ''){
  
                                      this.classImages.push(this.myMembership.class.image_6);
  
                                      if(this.myMembership.class.image_7 != null && this.myMembership.class.image_7 != ''){
  
                                          this.classImages.push(this.myMembership.class.image_7);
  
                                          if(this.myMembership.class.image_8 != null && this.myMembership.class.image_8 != ''){
  
                                              this.classImages.push(this.myMembership.class.image_8);
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  } 
              }
  
          }catch(error){
  
            componentsHelpers.sendError(this.$apollo, this.userId,'PublicInfoGymMemberships', 'classMembershipsDetailsPage', 'mounted - catch 1', error);
  
  componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
}
      },
  
      props: {
  
          showPanel: false,
  
          closeMembershipPage: {
  
              type: Function 
          },
  
          myMembership:{
          
              type: Object
          },
  
          myReload: {
  
              type: Function
          },
  
          refreshPageReady: {
  
              type: Function
          }
  
          // classId: 0
      },
  
      components: {
  
          cardImagesComponent,
          myDateBar,
          membershipSchedule
      },
  
      methods: {  
  
          setPaymentSwitch(){
  
              if(this.myMembership.pay_cash && this.myMembership.pay_points){
  
                  this.enablePaymentSwitch = true;
              }else{
  
                  if(this.myMembership.pay_cash){
  
                      this.paymentByPoints = false;
                  }
              }
          },
  
          membershipPeriod(){
  
              let period = '';            
  
              if(this.myMembership.in_years > 0){
                  
                  if(period != ''){
  
                      period = period + ', '
                  }
  
                  if(this.myMembership.in_years == 1){
  
                      period = period + `${this.myMembership.in_years} year`
  
                  }else{
  
                      period = period + `${this.myMembership.in_years} years`
                  }
              } 
              if(this.myMembership.in_months > 0){
                  
                  if(period != ''){
  
                      period = period + ', '
                  }
  
                  if(this.myMembership.in_months == 1){
  
                      period = period + `${this.myMembership.in_months} month`
  
                  }else{
  
                      period = period + `${this.myMembership.in_months} months`
                  }
              } 
              if(this.myMembership.in_days > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.myMembership.in_days == 1){
  
                      period = period + `${this.myMembership.in_days} day`;
  
                  }else{
  
                      period = period + `${this.myMembership.in_days} days`;
                  }
              } 
              if(this.myMembership.free_years > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.myMembership.free_years == 1){
  
                      period = period + `${this.myMembership.free_years} free year`;
  
                  }else{
  
                      period = period + `${this.myMembership.free_years} free years`;
                  }
              } 
              if(this.myMembership.free_months > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.myMembership.free_months == 1){
  
                      period = period + `+ ${this.myMembership.free_months} free month`;
  
                  }else{
  
                      period = period + `${this.myMembership.free_months} free months`;
                  }
              } 
              if(this.myMembership.free_days > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.myMembership.free_days == 1){
  
                      period = period + `+ ${this.myMembership.free_days} free day`;
  
                  }else{
  
                      period = period + `+ ${this.myMembership.free_days} free days`;
                  }
              }
  
              return period;
          },
  
          setType(){
              
              const types = this.myMembership.class.categories;
  
              for(let i = 0; i < types.length; i++){
  
                  if(i != types.length - 1){
                      
                      this.type = this.type + types[i].category.name + ', '
                  }
                  else {
                    
                    this.type = this.type + types[i].category.name;
                  }
              }
              return this.type;
          },  
  
          setFacility(){
              
              const facilities = this.myMembership.three_class_membership_facilities;
  
              for(let i = 0; i < facilities.length; i++){
  
                  if(i != facilities.length - 1){
                      
                      this.facility = this.facility + facilities[i].facility.name + ', '
                  }
                  else {
                    
                    this.facility = this.facility + facilities[i].facility.name;
                  }
              }
              // console.log(`type is ${this.type}`);
              return this.facility;
          },
  
  
          dayOfWeekAsString(dayIndex) {
          
              return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
          },
      },
  
      data: function() {
  
          return {
  
              paymentByPoints: true,
              enablePaymentSwitch: false,
  
              panelObject:{
  
                  minimizeAll: false,
                  onlyOnline: false,
                  categorizedSlots: new Array(),
                  dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
              },
              classImages: [],
              classMembershipsError: '',
              email: '',
              myDates: [],
              disableButton: false,
              type: '',
              facility: '',
              dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
  
              myEndDate: '',  
          }
      },  
  }
  </script>
  
  <style lang="scss">
  
  label{
    width: 150px;
  }
  
  
  </style>